import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { api } from '@/api/client';
import type { LedgerStatsResponse } from '@/api/types';

/**
 * Fetch stats for a single ledger.
 */
async function fetchLedgerStats(ledgerId: number): Promise<LedgerStatsResponse> {
    return api.get<LedgerStatsResponse>(`/api/ledgers/${ledgerId}/stats`);
}

/**
 * Hook to fetch stats for a single ledger.
 *
 * @param ledgerId - The ledger ID to fetch stats for
 * @param options - Optional React Query options
 */
export function useLedgerStats(
    ledgerId: number | undefined,
    options?: Omit<UseQueryOptions<LedgerStatsResponse, Error>, 'queryKey' | 'queryFn'>,
) {
    return useQuery({
        queryKey: ['ledger-stats', ledgerId],
        queryFn: () => fetchLedgerStats(ledgerId!),
        enabled: ledgerId !== undefined,
        staleTime: 5 * 60 * 1000, // 5 minutes
        ...options,
    });
}
